import type {
  CompanyLink,
  CompanySec,
  Defi,
  Eco,
  Exchange,
  Learn,
  LearnSec,
  Products,
  Section,
} from './types'

// NOTE https://mcoproduct.atlassian.net/browse/WRP1-664, no margin and derivative trading links

export const products_au: Products[] = [
  {
    tTitle: 'products.buyAndSell',
    tDesc: 'products.appDescription',
    href: '/app',
  },
  {
    tTitle: 'products.metalCards',
    tDesc: 'products.metalCardsDescription',
    href: '/cards',
  },
  {
    tTitle: 'products.pay',
    tDesc: 'products.payDescription',
    href: '/pay',
  },
  {
    tTitle: 'products.earn',
    tDesc: 'products.earnDescription',
    href: '/earn',
  },
  {
    tTitle: 'products.credit',
    tDesc: 'products.creditDescription',
    href: '/credit',
  },
]

export const exchange_au: Exchange[] = [
  {
    tTitle: 'products.exchangeIndex',
    tDesc: 'products.exchangeIndexDescription',
    href: 'https://crypto.com/exchange',
  },
  // {
  //   tTitle: "products.marginTrading",
  //   tDesc: "products.marginTradingDescription",
  //   href: "https://crypto.com/exchange/trade/margin/BTC_USDT",
  // },
  // {
  //   tTitle: "products.derivatives",
  //   tDesc: "products.derivativesDescription",
  //   href: "https://crypto.com/exchange/perpetual",
  // },
]
export const defi_au: Defi[] = [
  {
    tTitle: 'products.defiWallet',
    tDesc: 'products.defiWalletDescription',
    href: '/au/defi-wallet',
  },
  {
    tTitle: 'products.browserExt',
    tDesc: 'products.browserExtDescription',
    href: '/au/defi-wallet#wallet_extension',
  },
  {
    tTitle: 'products.desktopWallet',
    tDesc: 'products.desktopWalletDescription',
    href: '/au/defi-wallet#defi_wallet_desktop',
  },
]
export const eco_au: Eco[] = [
  {
    tTitle: 'products.payMerchant',
    tDesc: 'products.payMerchantDescription',
    href: '/au/pay-merchant',
  },
]

export const products_desktop_au: Section[] = [
  {
    tTitle: 'products.sectionTitle_getStarted',
    items: [
      {
        tTitle: 'products.categoryTitle_buyAndSell',
        items: [
          {
            tTitle: 'products.app',
            tDesc: 'products.appDescription',
            href: '/au/app',
          },
          {
            tTitle: 'products.nft',
            tDesc: 'products.nftDescription',
            href: 'https://crypto.com/nft',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_spend',
        items: [
          {
            tTitle: 'products.metalCards',
            tDesc: 'products.metalCardsDescription',
            href: '/au/cards',
          },
          {
            tTitle: 'products.pay',
            tDesc: 'products.payDescription',
            href: '/au/pay',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_grow',
        items: [
          {
            tTitle: 'products.earn',
            tDesc: 'products.earnDescription',
            href: '/au/earn',
          },
          {
            tTitle: 'products.credit',
            tDesc: 'products.creditDescription',
            href: '/au/credit',
          },
        ],
      },
    ],
  },
  {
    tTitle: 'products.sectionTitle_advancedTrading',
    items: [
      {
        tTitle: 'products.categoryTitle_exchange',
        items: [
          {
            tTitle: 'products.exchangeIndex',
            tDesc: 'products.exchangeIndexDescription',
            href: 'https://crypto.com/exchange',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_defi',
        items: [
          {
            tTitle: 'products.defiWallet',
            tDesc: 'products.defiWalletDescription',
            href: '/au/defi-wallet',
          },
          {
            tTitle: 'products.browserExt',
            tDesc: 'products.browserExtDescription',
            href: '/au/defi-wallet#wallet_extension',
          },
          {
            tTitle: 'products.desktopWallet',
            tDesc: 'products.desktopWalletDescription',
            href: '/au/defi-wallet#defi_wallet_desktop',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_ecosystem',
        items: [
          {
            tTitle: 'products.payMerchant',
            tDesc: 'products.payMerchantDescription',
            href: '/au/pay-merchant',
          },
        ],
      },
    ],
  },
]

export const learn_au: Learn[] = [
  {
    tTitle: 'learn.trending',
    tDesc: 'learn.trendingDescription',
    href: '/trending',
  },
  {
    tTitle: 'learn.marketUpdates',
    tDesc: 'learn.marketUpdatesDescription',
    href: '/market-updates',
  },
  {
    tTitle: 'learn.productNews',
    tDesc: 'learn.productNewsDescription',
    href: '/product-news',
  },
  {
    tTitle: 'learn.events',
    tDesc: 'learn.eventsDescription',
    href: '/events',
  },
  {
    tTitle: 'learn.university',
    tDesc: 'learn.universityDescription',
    href: '/university',
  },
  {
    tTitle: 'learn.reportsAndAnalysis',
    tDesc: 'learn.reportsAndAnalysisDescription',
    href: '/research',
  },
  {
    tTitle: 'learn.nftStories',
    tDesc: 'learn.nftStoriesDescription',
    href: '/nft-stories',
  },
]

export const company_au: CompanyLink[] = [
  {
    tTitle: 'company.about',
    tDesc: 'company.aboutDescription',
    href: '/au/about',
  },
  {
    tTitle: 'company.careers',
    tDesc: 'company.careersDescription',
    href: '/au/careers',
  },
  {
    tTitle: 'company.news',
    tDesc: 'company.newsDescription',
    href: 'https://crypto.com/company-news',
  },
  {
    tTitle: 'company.support',
    tDesc: 'company.supportDescription',
    href: 'https://help.crypto.com/en',
  },
  {
    tTitle: 'company.security',
    tDesc: 'company.securityDescription',
    href: '/au/security',
  },
  {
    tTitle: 'company.partners',
    tDesc: 'company.partnersDescription',
    href: '/au/partners',
  },
]

export const learn_desktop_au: LearnSec[] = [
  {
    tTitle: 'learn.categoryTitle_updates',
    items: [
      {
        tTitle: 'learn.trending',
        tDesc: 'learn.trendingDescription',
        href: '/trending',
      },
      {
        tTitle: 'learn.events',
        tDesc: 'learn.eventsDescription',
        href: '/events',
      },
      {
        tTitle: 'learn.productNews',
        tDesc: 'learn.productNewsDescription',
        href: '/product-news',
      },
      {
        tTitle: 'learn.marketUpdates',
        tDesc: 'learn.marketUpdatesDescription',
        href: '/market-updates',
      },
    ],
  },
  {
    tTitle: 'learn.categoryTitle_resources',
    items: [
      {
        tTitle: 'learn.university',
        tDesc: 'learn.universityDescription',
        href: '/university',
      },
      {
        tTitle: 'learn.reportsAndAnalysis',
        tDesc: 'learn.reportsAndAnalysisDescription',
        href: '/research',
      },
      {
        tTitle: 'learn.nftStories',
        tDesc: 'learn.nftStoriesDescription',
        href: '/nft-stories',
      },
    ],
  },
]

export const company_desktop_au: CompanySec[] = [
  {
    tTitle: 'company.sectionTitle_aboutUs',
    items: [
      {
        tTitle: 'company.about',
        tDesc: 'company.aboutDescription',
        href: '/au/about',
      },
      {
        tTitle: 'company.support',
        tDesc: 'company.supportDescription',
        href: 'https://help.crypto.com/en',
      },
      {
        tTitle: 'company.careers',
        tDesc: 'company.careersDescription',
        href: '/au/careers',
      },
      {
        tTitle: 'company.security',
        tDesc: 'company.securityDescription',
        href: '/au/security',
      },
      {
        tTitle: 'company.news',
        tDesc: 'company.newsDescription',
        href: 'https://crypto.com/company-news',
      },
      {
        tTitle: 'company.partners',
        tDesc: 'company.partnersDescription',
        href: '/au/partners',
      },
    ],
  },
]
